import { ReactNode } from "react";
import { createPortal } from "react-dom";
import { twMerge } from "tailwind-merge";
import { Backdrop } from "@clarityos/ui/backdrop";

export interface ModalProps {
  open: boolean;
  onClose: VoidFunction;
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
  testId?: string;
}

export function Modal({
  open,
  onClose,
  children,
  className,
  ariaLabel,
  testId,
}: ModalProps) {
  if (!open) return null;

  return createPortal(
    <div
      onClick={(e) => e.stopPropagation()}
      className="animate-v5-overlay-fade-in fixed inset-0 z-50 flex items-center justify-center"
    >
      <Backdrop onClick={onClose} />
      {open && (
        <div
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-label={ariaLabel}
          data-testid={testId}
          className={twMerge(
            "animate-v5-dialog-in rounded-8 bg-surface-raised shadow-xxl relative z-1 p-7 pb-6",
            className,
          )}
        >
          {children}
        </div>
      )}
    </div>,
    document.body,
  );
}
